module.exports = __webpack_public_path__ + "static/media/Add_Icon.0a1e3ce0.svg";